import React from 'react';
import { IconComponent } from '../icons/iconComponent';

const Label = (props) => {
  const {
    icon,
    iconAfter,
    children,
    className,
    iconClassName,
  } = props;
  const iconBefore = icon || props.iconBefore;
  const IconList = (setIcon, setIconClass) => {
    if (!setIcon) {
      return setIcon;
    }
    return <IconComponent icon={setIcon}
                          className={`${children ? setIconClass : ''} ${iconClassName || ''} flex-shrink-0 mt-0.5`}/>;
  };
  return (
          <span
                  className={`flex items-center text-left |  ${className || ''}`}
          >
      {IconList(iconBefore, 'mr-2')}
            {children}
            {IconList(iconAfter, 'ml-2')}
    </span>
  );
};

export default Label;
